import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchLabReviewsApi } from 'api/lab-reviews-api';
import { setQuickLinks } from 'reducers/quick-links-slice';
import { getQueryString } from 'utils/filters-util';

const initialState = {
  activeColumns: [],
  labReviews: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchLabReviewsListing = createAsyncThunk(
  'lab-reviews/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
    try {
      const paramsObj = {
        'q[s]': 'created_at desc',
        ...updatedParamsObject,
      };
      const res = await fetchLabReviewsApi({}, getQueryString(paramsObj));
      if (res?.status) {
        dispatch(setQuickLinks(res?.user_filters));
      }
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const LabReviewsSlice = createSlice({
  name: 'labreviews',
  initialState,
  reducers: {
    setLabReviewsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setLabReviewsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchLabReviewsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchLabReviewsListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.labReviews = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchLabReviewsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setLabReviewsActiveColumn, setLabReviewsLoading } = LabReviewsSlice.actions;
export default LabReviewsSlice.reducer;
